/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { PropsWithChildren } from "react";
import sass from "components-new/Switch/index.module.sass";
import cn from "classnames";

interface ISwitchInterface
	extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
		PropsWithChildren {}

const Switch: React.FC<ISwitchInterface> = ({ disabled = false, checked = false, className, children, ...rest }) => {
	return (
		<label tabIndex={0} className={cn(sass.wrapper, className)}>
			<div
				data-checked={checked ? "true" : "false"}
				className={cn(disabled ? sass.disabled : sass.checked, sass[`${disabled ? "disabled" : "checked"}-${checked}`])}
			/>
			<span className={sass.text}>{children}</span>
			<input tabIndex={-1} hidden type="checkbox" checked={checked} disabled={disabled} {...rest} />
		</label>
	);
};

export default Switch;
